export enum RESPONSE_QR_POLLING {
    VALIDO = 1,
    EXPIRADO = 2,
    ESCANEADO = 3,
    AUTENTICADO = 4,
}